<script>
	export default {
		name: 'perguntasfrequentes',
		data() {
			return {
			}
		},
		methods: {
			clearClass() {
				let el = document.querySelectorAll('#perguntas-frequentes .panel');
				el.forEach(function(e) {
					e.classList.remove('show');

				}, this);
			},
			controlAcordion() {
				let ac = document.querySelectorAll('#perguntas-frequentes .accordion');
				ac.forEach((e) => {
					e.addEventListener('click', (e) => {
						this.clearClass();
						e.target.nextElementSibling.classList.toggle('show');
					})
				})
			}
		},
		created() {
			this.$nextTick(function() {
				this.controlAcordion();
			})
		}
	};
</script>

<template>
	<div>
		<div id="contato" class="row">
			<div class="img-bg"></div>
			<div class="container">
				<section class="section">
					<h2 class="title">contato</h2>
					<iframe src="https://eokoe2.typeform.com/to/DCN5XL?typeform-embed=embed-widget&embed-hide-footer=true&embed-hide-headers=true&embed-opacity=0" frameborder="0" data-transparency="100" data-hide-headers=true data-hide-footer=true style="width: 100%; height: 500px;" allowtransparency="true"></iframe>
				</section>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>

	#perguntas-frequentes {
		background-color: #2c3e50;
		padding-top: 100px;
		.wrap-info--text {
			font-size: 25px;
			color: #676767;
			font-weight: 300;
			width: 100%;
			color: #fff;
			p {
				font-size: 20px;

			}
			* {
				margin-bottom: 20px;
			}
		}
		h1 {
			display: block;
			margin-bottom: 54px;
			font-weight: 600;
			color: #4ab957;
		}
		li {
			display: list-item;
			list-style-type: circle;
		}
		.wrap-acordion {
			margin-bottom: 20px;
		}
		.accordion {
			outline: none;
			border: none;
			background: rgba(255, 255, 255, 0.35);
			border-radius: 8px;
			color: #fff;
			font-size: 20px;
			text-align: left;
			width: 100%;
			cursor: pointer;
			padding: 15px 15px 15px 64px;
		}
		.panel {
			margin: 15px;
			color: #fff;
			display: none;
			&.show {
				display: block;
			}
			ul {
				li {
					float: none;
				}
			}
			&:after {
				content: '';
				display: table;
				clear: both;
			}
			p{
				margin-bottom: 1rem;
				margin-top: 1rem;
			}
		}
		blockquote {
			padding: 10px 20px;
			margin: 0 0 20px;
			font-size: 17.5px;
			border-left: 5px solid #eee;
			margin: 20px;
		}
		code {
			padding: 2px 4px;
			font-size: 90%;
			color: #c7254e;
			background-color: #f9f2f4;
			border-radius: 4px;
		}
		.subtitle {
			font-weight: bold;
			margin-top: 2rem;
			margin-bottom: 0;
		}
		.campaign {
			margin-top: 2rem;
		}
		.table-title {
			font-weight: bold;
			margin-bottom: 0;
			color: rgb(74, 185, 87);
			padding-bottom: -0.5em;
		}
	}

	#contato {
		margin: auto;
		text-align: center;

		.img-bg {
			background-image: url('../../img/bg-perguntas.jpg');
			background-size: cover;
			background-repeat: no-repeat;
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
			z-index: -1;
		}

		h2 {
			color: white;
			text-transform: uppercase;
		}

		form {
			.field-row {
				width: 100%;
				box-sizing: border-box;
				background-clip: padding-box;
				position: relative;
				textarea,
				input {
					width: 100%;
					overflow: visible;
					display: table;
					outline: none;
					border: none;
					margin-bottom: 20px;
					box-sizing: border-box;
					padding: 20px 10px 20px 20px;
					border-radius: 8px;
					font-size: 20px;
					font-weight: bold;
					background-color: #fff;
					display: block;
					color: #686868;

					&[type=submit]{
						width: 40%;
						margin: 0 auto;
					}
				}
				&.radio-buttons {
					min-height: 60px;
					span.mask {
						float: left;
						margin-left: 20px;
					}
					li {
						position: relative;
						display: inline-block;
						color: #fff;
						width: 30%;
						@media (max-width: 768px) {
							width: 100%;
						}
						label {
							width: 20px;
							height: 20px;
							border: solid 2px #fff;
							display: block;
							position: absolute;
							top: 0;
							left: 2px;
							border-radius: 50px;
							white-space: nowrap;
							cursor: pointer;
							text-indent: 100%;
							float: left;
							input {
								display: inline-block;
							}
						}
					}
					input {
						float: left;
						width: auto;
						visibility: hidden;
					}
					// input:focus+label {
					//     background-color: gray;
					// }
					input:checked +label{
						background-color: gray;

					}
				}
			}
		}
	}

	table,
	thead,
	tbody,
	tfoot,
	tr,
	th,
	td {
		width: auto;
		height: auto;
		font-size: 1em;
		vertical-align: top;
		background-color: transparent;
		border: 0;
		padding: 1em;

		@media screen and (max-width:400px) {
			display: block;
		}
	}

	table {
		width: 100%;
		max-width: 100%;
		/* line-height */
		font-size: 100%;
		font-family: inherit;
		font-feature-settings: 'kern' 1, 'liga' 1, 'calt' 1, 'pnum' 0, 'tnum' 1, 'onum' 0, 'lnum' 1, 'dlig' 0;
		border-collapse: collapse;
		empty-cells: show;
		@media screen and (max-width:400px) {
			padding: 0;
		}
	}

	table p,
	table li {
		font-size: 1em;
	}


	tr {
		@media screen and (max-width:400px) {
			padding: 0;
			padding-bottom: 0.5em;
			padding-top: 0.5em;
				border-bottom: 2px solid white;
			&:last-child {
				margin-bottom: 0;
			}
		}
	}


	th {
		font-weight: bold;
		text-transform: capitalize;
		@media screen and (max-width:400px) {
			text-transform: capitalize;
			padding-top: 0.5em;
		}
	}



	td {
		border-bottom: 2px solid white;
		font-family: inherit;


		@media screen and (max-width:400px) {
		border-bottom: 0;
			padding-bottom: 0.5em;
			padding-top: 0.5em;
			&:empty {
				display: none;
			}
		}
	}

	thead {
		@media screen and (max-width:400px) {
			display: none;
		}
	}

	thead th,
	thead td {
		background-color: rgb(74, 185, 87);
		color: white;
		text-align: left;
		vertical-align: bottom;
	}

	thead th:first-child,
	tfoot th:first-child {
		text-align: left;
	}

	tbody {
		text-align: left;
		@media screen and (max-width:400px) {
			padding: 0;
		}
	}

	tbody th {
		text-align: left;
	}

	tbody td {
		text-align: left;
		@media screen and (max-width:400px) {
			text-align: left;
			&[title] {
				text-align: right;
				&::before {
					float: left;
					font-style: italic;
					content: attr(title)': ';
				}
			}
		}
		font-variant-numeric: lining-nums oldstyle-nums;
	}

	tbody tr:nth-child(odd) {
		background-color: palette('box', 'base');
	}

	td img {
		vertical-align: top;
	}

	tbody tr:nth-of-type(odd)>th,
	tbody tr:nth-of-type(odd)>td {
		@media screen and (max-width:400px) {
			background-color: transparent;
		}
	}

	tfoot th,
	tfoot td {
		background-color: rgb(74, 185, 87);
		color: white;
		vertical-align: top;
		text-align: left;

		@media screen and (max-width:400px) {
			display: none;
		}
	}


</style>



// WEBPACK FOOTER //
// _source/javascript/components/perguntasfrequentes.vue